export default {
  authenticatedLoggedOut: 'You have been logged out due to inactivity, please log in again',
  mustBeLoggedIn: 'You must be logged in to view that',
};
